module.exports = __webpack_public_path__ + "static/img/son1_active.0bae1897.png";